"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BACK_TO_TOP_DISTANCE = void 0;
const BACK_TO_TOP_DISTANCE = exports.BACK_TO_TOP_DISTANCE = 100;
//# sourceMappingURL=BackToTop.types.js.map